exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offline-message-container[data-v-00ebbe92]{position:fixed;top:0;left:0;width:100vw;z-index:9999}.offline-message-container .priority-message[data-v-00ebbe92]{padding:.2em 1em;box-shadow:0 2px 10px -4px rgba(27,33,58,.4);background-color:#fff;font-weight:700;font-size:1.2em;text-align:center;z-index:9999}.offline-message-container .priority-message.message-offline[data-v-00ebbe92]{color:#ff3860}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00ebbe92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseOffline.vue
// module id = vkME
// module chunks = 18